import { Icon, IconSize, Menu, MenuItem, Position } from "@blueprintjs/core"
import CustomPopover from "components/Atoms/CustomPopover"
import React from "react"
import { NavLink } from "react-router-dom"
import CustomTooltip from "../Atoms/CustomTooltip"
const SubNavItem = ({
  path,
  parentPath,
  text,
  icon: IconComponent,
  children,
}) => {
  return (
    <NavLink to={`${parentPath}/${path}`} className="vt-sidebar-link">
      {({ isActive }) => {
        return (
          <MenuItem
            active={isActive}
            text={text}
            icon={
              typeof IconComponent === "string" ? (
                <Icon
                  icon={IconComponent}
                  style={{ marginRight: 10 }}
                  color="#1C5D42"
                  size={IconSize.STANDARD}
                />
              ) : (
                <IconComponent
                  style={{ marginRight: 10 }}
                  height={IconSize.STANDARD}
                  width={IconSize.STANDARD}
                  className="svg-green"
                />
              )
            }
          >
            {children}
          </MenuItem>
        )
      }}
    </NavLink>
  )
}

const SidebarItem = ({
  desc,
  path,
  icon: IconComponent,
  submenu,
  children,
}) => {
  return (
    <>
      <CustomPopover
        popoverClassName="vt-sidebar-subnav-popover"
        position={Position.RIGHT_BOTTOM}
        disabled={!submenu}
        transitionDuration={0}
        minimal={true}
        interactionKind="hover"
        content={<Menu className="vt-sidebar-subnav">{children}</Menu>}
      >
        <NavLink to={path} className={"vt-sidebar-item"}>
          <CustomTooltip
            isOpen={!submenu ? undefined : false}
            content={desc}
            position={Position.RIGHT}
            popoverClassName="vt-sidebar-tooltip-popover"
          >
            {typeof IconComponent === "string" ? (
              <Icon
                icon={IconComponent}
                className="vt-sidebar-item-icon"
                iconSize={IconSize.LARGE}
              />
            ) : (
              <IconComponent
                className="vt-sidebar-item-icon"
                height={IconSize.LARGE}
                width={IconSize.LARGE}
              />
            )}
          </CustomTooltip>
          {submenu && (
            <Icon
              icon="more"
              iconSize={14}
              className="vt-sidebar-subroute-drawer"
            />
          )}
        </NavLink>
      </CustomPopover>
    </>
  )
}

SidebarItem.defaultProps = {
  exact: false,
  submenu: false,
}
export default SidebarItem
export { SubNavItem }
